<i18n src="./resources/locales.json"></i18n>

<template>
  <li>
    <EcsLiveTimeAgo v-if="item.isLive" :since="item.value" />
    <span v-else :style="cssStyle">{{ label }}</span>
    <ul v-if="showList" class="kpi-list">
      <EcsBusinessProcessMonitoringKpiItem
        v-for="kpi in item.kpis"
        :key="kpi.id"
        :item="kpi"
        :business-process-id="businessProcessId"
      />
    </ul>
  </li>
</template>

<script>
import EcsBusinessProcessHealthMixins from '@/mixins/ecs-business-process-health/EcsBusinessProcessHealthMixins';
import EcsLiveTimeAgo from '@/components/ecs-live-time-ago/EcsLiveTimeAgo';

export default {
  name: 'EcsBusinessProcessMonitoringKpiItem',

  components: {
    EcsLiveTimeAgo
  },

  mixins: [EcsBusinessProcessHealthMixins],

  props: {
    item: {
      type: Object,
      required: true
    },
    businessProcessId: {
      type: String,
      required: true
    }
  },

  computed: {
    label() {
      const { id, amount, type, units, percentage } = this.item;
      const description = this.$t(`kpis.${id}`);
      const percentageDetail = percentage ? `(${this.getFormattedValue(percentage.amount)}%)` : '';
      return `${this.getFormattedValue(amount, type)}${units} ${description} ${percentageDetail}`;
    },

    cssStyle() {
      const color = this.getKpiColor(this.item.status);
      return { color };
    },

    showList() {
      return this.item.kpis && this.item.kpis.length;
    }
  }
};
</script>

<style scoped>
.kpi-list {
  list-style-type: none;
  padding-left: 8px;
}
</style>
